import { ModuleNavigationState } from './types';

export const DEFAULT_STATE: ModuleNavigationState = {
  type: null,
  navigationItems: {},
};
